// components/TableRow.jsx
import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import actionsIcon from '../../../../Assets/Icons/threeDotsVertical.svg';
import ActionDropdown from './ActionDropdown';


const TableRow = ({ row, index, refresh, setSelectedRow, setOpenLinkModal, setOpenPackageModal }) => {
    const [showActions, setShowActions] = useState(false);
    const dropdownRef = useRef(null);

    const handleOpenAction = () => {
        if (row.ComponentState === "Adding to Playground") {
            Swal.fire({
                title: "Information!",
                html: `For instructions on adding Component to the Playground, click <a href="https://dev.azure.com/WebAppStudio-React/WebAppStudio-React/_wiki/wikis/WebAppStudio-React.wiki/293/Steps-to-Add-Component-to-Playground" target="_blank">here</a>`,
                icon: "info",
                confirmButtonText: "OK",
            });
        } else if (row.ComponentState === "Added to Playground") {
            setShowActions(false);
        } else {
            setShowActions(!showActions);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowActions(false);
            }
        };

        if (showActions) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showActions]);
    return (
        <tr className="border-t hover:bg-gray-50 relative">
            <td className="px-4 py-2">{index + 1}</td>
            <td className="px-4 py-2">{row.ComponentName}</td>
            <td className="px-4 py-2">{row.Category}</td>
            <td className="px-4 py-2">{row.Technology}</td>
            <td className="px-4 py-2">{row.ComponentState}</td>
            <td className="px-4 py-2">{row.ComponentDetails}</td>
            <td className="px-4 py-2 relative" ref={dropdownRef}>
                <img
                    src={actionsIcon}
                    alt="Actions"
                    className="w-5 h-5 cursor-pointer"
                    onClick={handleOpenAction}
                />
                {showActions && (
                    <ActionDropdown
                        row={row}
                        refresh={refresh}
                        closeDropdown={() => setShowActions(false)}
                        setSelectedRow={setSelectedRow}
                        openLinkModal={() => setOpenLinkModal(true)}
                        openPackageModal={() => setOpenPackageModal(true)}
                    />
                )}
            </td>
        </tr>
    );
};

export default TableRow;
